import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { jwtDecode } from "jwt-decode";
import {API_BASED_URL} from '../config.js'; 
import { useNavigate } from 'react-router-dom';

function ChangePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Check if passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // Get authToken from localStorage
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      setError('You are not logged in. Please log in and try again.');
      return;
    }
    const decoded = jwtDecode(authToken);
    const userId = decoded.userId;

    try {
      // Send API request to change password
      const response = await fetch(`${API_BASED_URL}api/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${authToken}`, // Pass the token for authentication
        },
        body: JSON.stringify({ userId:userId , newPassword: password }),
      });
      if (response.status && (response.status === 401 || response.status===403)) {
        alert("Session expired. Please log in again.");
        localStorage.clear(); // Clear localStorage to logout user
        // Redirect to login page
        navigate("/login");
        return;
      }
      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to change password');
        return;
      }
      
      // console.log(response);
      setSuccess('Password changed successfully');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      // console.log(err.status);
      // console.error('Error changing password:', err);
      setError('An error occurred. Please try again later. You can also try logging in again');
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Change Password</h2>
      <form onSubmit={handleChangePassword}>
        <div className="relative mb-2">
          <input
            type={showNew ? 'text' : 'password'}
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border p-2 rounded w-full pr-10"
            required
          />
          <button type="button" aria-label={showNew ? 'Hide password' : 'Show password'} onClick={() => setShowNew(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showNew ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
        </div>
        <div className="relative mb-2">
          <input
            type={showConfirm ? 'text' : 'password'}
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="border p-2 rounded w-full pr-10"
            required
          />
          <button type="button" aria-label={showConfirm ? 'Hide password' : 'Show password'} onClick={() => setShowConfirm(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showConfirm ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Change Password
        </button>
      </form>
      {error && <p className="text-red-500 mt-2">{error}</p>}
      {success && <p className="text-green-500 mt-2">{success}</p>}
    </div>
  );
}

export default ChangePassword;
